import { Helpers } from '../../helpers';
import { IEconomicsSetting } from '../../interfaces/ieconomics-setting';
import { EconomicsSettingsCalculationType } from '../economics-settings-calculation-type';
import { EconomicsSettingsFacilityInput } from '../economics-settings-facility-input';
import { EconomicsSettingsVariableAnnualInput } from '../economics-settings-variable-annual-input';
import { Scenario } from '../scenario';

export class EconomicsSettingBase {
  EconomicsSettingId: number;
  ScenarioId: number;
  TerminalPeriod: number | null;
  DiscountRate: number | null;
  AbandonmentCost: number | null;
  AverageWellsAvailableToDrill: number | null;
  CountOfFacilityExpansions: number | null;
  EconomicsSettingsCalculationTypeId: number;
  CapitalExpensesDrillingProjectCost: number | null;
  CapitalExpensesCompletionsProjectCost: number | null;
  CapitalExpensesFacilitiesProjectsCost: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  EconomicsSettingsFacilityInputs_EconomicsSetting?: Array<EconomicsSettingsFacilityInput> | null;
  EconomicsSettingsVariableAnnualInputs_EconomicsSetting?: Array<EconomicsSettingsVariableAnnualInput> | null;
  EconomicsSettingsCalculationType?: EconomicsSettingsCalculationType;
  Scenario?: Scenario;

  constructor(item?: IEconomicsSetting) {
    if (item) {

      this.EconomicsSettingId = item.EconomicsSettingId;
      this.ScenarioId = item.ScenarioId;
      this.TerminalPeriod = item.TerminalPeriod;
      this.DiscountRate = item.DiscountRate;
      this.AbandonmentCost = item.AbandonmentCost;
      this.AverageWellsAvailableToDrill = item.AverageWellsAvailableToDrill;
      this.CountOfFacilityExpansions = item.CountOfFacilityExpansions;
      this.EconomicsSettingsCalculationTypeId = item.EconomicsSettingsCalculationTypeId;
      this.CapitalExpensesDrillingProjectCost = item.CapitalExpensesDrillingProjectCost;
      this.CapitalExpensesCompletionsProjectCost = item.CapitalExpensesCompletionsProjectCost;
      this.CapitalExpensesFacilitiesProjectsCost = item.CapitalExpensesFacilitiesProjectsCost;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.EconomicsSettingsFacilityInputs_EconomicsSetting = Helpers.createClassArray(EconomicsSettingsFacilityInput, item.EconomicsSettingsFacilityInputs_EconomicsSetting);
      this.EconomicsSettingsVariableAnnualInputs_EconomicsSetting = Helpers.createClassArray(EconomicsSettingsVariableAnnualInput, item.EconomicsSettingsVariableAnnualInputs_EconomicsSetting);
      this.EconomicsSettingsCalculationType = new EconomicsSettingsCalculationType(item.EconomicsSettingsCalculationType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}